<template>

<div v-if="isLoadingStrong" class="overlay-loader fixed inset-0 bg-white bg-opacity-100 flex items-center justify-center z-[9999999999999999]">
  <div class="loader loader--style8" title="Loading">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="40px"
      height="50px"
      viewBox="0 0 24 30"
      style="enable-background:new 0 0 50 50;"
      xml:space="preserve"
    >
      <rect x="0" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="8" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="16" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  </div>
</div>

<div v-if="isLoading" class="overlay-loader fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-[999999999999999]">
  <div class="loader loader--style8" title="Loading">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="40px"
      height="50px"
      viewBox="0 0 24 30"
      style="enable-background:new 0 0 50 50;"
      xml:space="preserve"
    >
      <rect x="0" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="8" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="16" y="10" width="4" height="10" class="gradient-bar">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  </div>
</div>
<div :class="['relative', (isMobile || isBig) ? 'p-[5rem] pt-[3.5rem]' : 'p-[20vw] pt-[4rem]']">

<div class="text-success text-center p-4 rounded-lg font-semibold mt-2">
  {{ $t('order.success') }}
  </div>

  <div class="text-details-success text-center p-4 rounded-lg font-semibold">
    {{ $t('order.preparing') }}
  </div>

  <div class="immediate-section mt-[3rem]">
    <h3 class="next-step mb-7">{{ $t('order.orderDetails') }}</h3>

    <div class="grid grid-cols-2 gap-2">
      <span class="text-detail mb-3">
        {{ $t('order.orderDate') }}
      </span>
      <span class="date-detail flex items-center justify-end mb-3">
        {{ getRenewalDate('eur') }}
      </span>
      
      <span v-if="getQuantity('eur') > 0" class="text-detail inline-flex items-center space-x-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 24 18" fill="none" style="margin-right: 15px;">
          <g clip-path="url(#clip0_1150_1995)">
            <path d="M0 0H24V18H0V0Z" fill="#003399"/>
            <path d="M11.9991 2.86401L11.7324 3.7529L12.1769 3.84179L11.9991 2.86401Z" fill="#FFCC00"/>
            <path d="M11.999 2.86401L12.2656 3.7529L11.8212 3.84179L11.999 2.86401Z" fill="#FFCC00"/>
            <path d="M12.8461 3.47822L11.9183 3.49929L11.9711 3.94945L12.8461 3.47822Z" fill="#FFCC00"/>
            <path d="M12.8453 3.47832L12.0824 4.00662L11.8605 3.61139L12.8453 3.47832Z" fill="#FFCC00"/>
            <path d="M12.5225 4.47193L12.2158 3.59606L11.804 3.78538L12.5225 4.47193Z" fill="#FFCC00"/>
            <path d="M12.5224 4.47192L11.7842 3.90954L12.0915 3.57639L12.5224 4.47192Z" fill="#FFCC00"/>
            <path d="M11.1539 3.47822L12.0817 3.49929L12.0289 3.94945L11.1539 3.47822Z" fill="#FFCC00"/>
            <path d="M11.1547 3.47832L11.9176 4.00662L12.1395 3.61139L11.1547 3.47832Z" fill="#FFCC00"/>
            <path d="M11.4775 4.47193L11.7842 3.59606L12.196 3.78538L11.4775 4.47193Z" fill="#FFCC00"/>
            <path d="M11.4776 4.47192L12.2158 3.90954L11.9085 3.57639L11.4776 4.47192Z" fill="#FFCC00"/>
            <path d="M11.9991 13.5308L11.7324 14.4197L12.1769 14.5085L11.9991 13.5308Z" fill="#FFCC00"/>
            <path d="M11.999 13.5308L12.2656 14.4197L11.8212 14.5085L11.999 13.5308Z" fill="#FFCC00"/>
            <path d="M12.8461 14.145L11.9183 14.166L11.9711 14.6162L12.8461 14.145Z" fill="#FFCC00"/>
            <path d="M12.8453 14.1451L12.0824 14.6734L11.8605 14.2781L12.8453 14.1451Z" fill="#FFCC00"/>
            <path d="M12.5225 15.1387L12.2158 14.2628L11.804 14.4521L12.5225 15.1387Z" fill="#FFCC00"/>
            <path d="M12.5224 15.1387L11.7842 14.5763L12.0915 14.2431L12.5224 15.1387Z" fill="#FFCC00"/>
            <path d="M11.1539 14.145L12.0817 14.166L12.0289 14.6162L11.1539 14.145Z" fill="#FFCC00"/>
            <path d="M11.1547 14.1451L11.9176 14.6734L12.1395 14.2781L11.1547 14.1451Z" fill="#FFCC00"/>
            <path d="M11.4775 15.1387L11.7842 14.2628L12.196 14.4521L11.4775 15.1387Z" fill="#FFCC00"/>
            <path d="M11.4776 15.1387L12.2158 14.5763L11.9085 14.2431L11.4776 15.1387Z" fill="#FFCC00"/>
            <path d="M6.6651 8.19727L6.39844 9.08615L6.84288 9.17504L6.6651 8.19727Z" fill="#FFCC00"/>
            <path d="M6.66497 8.19727L6.93164 9.08615L6.4872 9.17504L6.66497 8.19727Z" fill="#FFCC00"/>
            <path d="M7.51209 8.81148L6.5843 8.83254L6.63711 9.2827L7.51209 8.81148Z" fill="#FFCC00"/>
            <path d="M7.51135 8.81157L6.74837 9.33987L6.52649 8.94464L7.51135 8.81157Z" fill="#FFCC00"/>
            <path d="M7.18856 9.80518L6.88182 8.92931L6.47001 9.11864L7.18856 9.80518Z" fill="#FFCC00"/>
            <path d="M7.18839 9.80517L6.45018 9.24279L6.7575 8.90964L7.18839 9.80517Z" fill="#FFCC00"/>
            <path d="M5.81994 8.81148L6.74773 8.83254L6.69492 9.2827L5.81994 8.81148Z" fill="#FFCC00"/>
            <path d="M5.82069 8.81157L6.58366 9.33987L6.80554 8.94464L5.82069 8.81157Z" fill="#FFCC00"/>
            <path d="M6.14347 9.80518L6.45021 8.92931L6.86202 9.11864L6.14347 9.80518Z" fill="#FFCC00"/>
            <path d="M6.14364 9.80517L6.88185 9.24279L6.57454 8.90964L6.14364 9.80517Z" fill="#FFCC00"/>
            <path d="M8.87606 5.22656L9.61427 4.66417L9.30696 4.33102L8.87606 5.22656Z" fill="#FFCC00"/>
            <path d="M8.87589 5.22657L9.18263 4.3507L9.59444 4.54002L8.87589 5.22657Z" fill="#FFCC00"/>
            <path d="M8.55311 4.23296L9.31609 4.76125L9.53797 4.36603L8.55311 4.23296Z" fill="#FFCC00"/>
            <path d="M8.55236 4.23286L9.48015 4.25393L9.42735 4.70409L8.55236 4.23286Z" fill="#FFCC00"/>
            <path d="M9.39753 3.61865L9.13086 4.50754L9.5753 4.59643L9.39753 3.61865Z" fill="#FFCC00"/>
            <path d="M9.3974 3.61865L9.66406 4.50754L9.21962 4.59643L9.3974 3.61865Z" fill="#FFCC00"/>
            <path d="M9.92082 5.22656L9.1826 4.66417L9.48992 4.33102L9.92082 5.22656Z" fill="#FFCC00"/>
            <path d="M9.92098 5.22657L9.61424 4.3507L9.20243 4.54002L9.92098 5.22657Z" fill="#FFCC00"/>
            <path d="M10.2438 4.23271L9.48079 4.76101L9.25891 4.36579L10.2438 4.23271Z" fill="#FFCC00"/>
            <path d="M10.2445 4.23262L9.31673 4.25369L9.36953 4.70385L10.2445 4.23262Z" fill="#FFCC00"/>
            <path d="M7.94247 7.20411L7.63573 6.32824L7.22392 6.51756L7.94247 7.20411Z" fill="#FFCC00"/>
            <path d="M7.9423 7.2041L7.20409 6.64171L7.5114 6.30856L7.9423 7.2041Z" fill="#FFCC00"/>
            <path d="M6.89754 7.2041L7.63576 6.64171L7.32844 6.30856L6.89754 7.2041Z" fill="#FFCC00"/>
            <path d="M6.89738 7.20411L7.20412 6.32824L7.61593 6.51756L6.89738 7.20411Z" fill="#FFCC00"/>
            <path d="M6.57459 6.21025L7.33757 6.73855L7.55945 6.34333L6.57459 6.21025Z" fill="#FFCC00"/>
            <path d="M6.57385 6.21016L7.50163 6.23122L7.44883 6.68138L6.57385 6.21016Z" fill="#FFCC00"/>
            <path d="M8.26525 6.21025L7.50227 6.73855L7.28039 6.34333L8.26525 6.21025Z" fill="#FFCC00"/>
            <path d="M8.266 6.21016L7.33821 6.23122L7.39101 6.68138L8.266 6.21016Z" fill="#FFCC00"/>
            <path d="M7.42083 5.59595L7.6875 6.48484L7.24306 6.57372L7.42083 5.59595Z" fill="#FFCC00"/>
            <path d="M7.42096 5.59595L7.1543 6.48484L7.59874 6.57372L7.42096 5.59595Z" fill="#FFCC00"/>
            <path d="M8.26795 11.5561L7.34016 11.5772L7.39297 12.0273L8.26795 11.5561Z" fill="#FFCC00"/>
            <path d="M8.2672 11.5562L7.50423 12.0845L7.28235 11.6893L8.2672 11.5562Z" fill="#FFCC00"/>
            <path d="M7.94442 12.5501L7.63768 11.6742L7.22587 11.8635L7.94442 12.5501Z" fill="#FFCC00"/>
            <path d="M7.94425 12.55L7.20604 11.9877L7.51336 11.6545L7.94425 12.55Z" fill="#FFCC00"/>
            <path d="M6.8995 12.55L7.63771 11.9877L7.33039 11.6545L6.8995 12.55Z" fill="#FFCC00"/>
            <path d="M6.89933 12.5501L7.20607 11.6742L7.61788 11.8635L6.89933 12.5501Z" fill="#FFCC00"/>
            <path d="M7.42279 10.9421L7.68945 11.831L7.24501 11.9199L7.42279 10.9421Z" fill="#FFCC00"/>
            <path d="M7.42292 10.9421L7.15625 11.831L7.60069 11.9199L7.42292 10.9421Z" fill="#FFCC00"/>
            <path d="M6.57775 11.5563L7.50554 11.5774L7.45274 12.0276L6.57775 11.5563Z" fill="#FFCC00"/>
            <path d="M6.5785 11.5564L7.34148 12.0847L7.56336 11.6895L6.5785 11.5564Z" fill="#FFCC00"/>
            <path d="M10.1976 13.3454L9.26985 13.3665L9.32265 13.8166L10.1976 13.3454Z" fill="#FFCC00"/>
            <path d="M10.1969 13.3455L9.43391 13.8738L9.21203 13.4786L10.1969 13.3455Z" fill="#FFCC00"/>
            <path d="M9.87411 14.3394L9.56737 13.4635L9.15556 13.6528L9.87411 14.3394Z" fill="#FFCC00"/>
            <path d="M9.87394 14.3394L9.13573 13.777L9.44304 13.4438L9.87394 14.3394Z" fill="#FFCC00"/>
            <path d="M8.82918 14.3394L9.5674 13.777L9.26008 13.4438L8.82918 14.3394Z" fill="#FFCC00"/>
            <path d="M8.82902 14.3394L9.13576 13.4635L9.54757 13.6528L8.82902 14.3394Z" fill="#FFCC00"/>
            <path d="M9.35247 12.7314L9.61914 13.6203L9.1747 13.7092L9.35247 12.7314Z" fill="#FFCC00"/>
            <path d="M9.3526 12.7314L9.08594 13.6203L9.53038 13.7092L9.3526 12.7314Z" fill="#FFCC00"/>
            <path d="M8.50744 13.3457L9.43523 13.3667L9.38242 13.8169L8.50744 13.3457Z" fill="#FFCC00"/>
            <path d="M8.50819 13.3458L9.27116 13.874L9.49304 13.4788L8.50819 13.3458Z" fill="#FFCC00"/>
            <path d="M17.3329 8.19727L17.5996 9.08615L17.1552 9.17504L17.3329 8.19727Z" fill="#FFCC00"/>
            <path d="M17.3331 8.19727L17.0664 9.08615L17.5109 9.17504L17.3331 8.19727Z" fill="#FFCC00"/>
            <path d="M16.486 8.81148L17.4137 8.83254L17.3609 9.2827L16.486 8.81148Z" fill="#FFCC00"/>
            <path d="M16.4867 8.81157L17.2497 9.33987L17.4716 8.94464L16.4867 8.81157Z" fill="#FFCC00"/>
            <path d="M16.8095 9.80518L17.1162 8.92931L17.528 9.11864L16.8095 9.80518Z" fill="#FFCC00"/>
            <path d="M16.8097 9.80517L17.5479 9.24279L17.2406 8.90964L16.8097 9.80517Z" fill="#FFCC00"/>
            <path d="M18.1781 8.81148L17.2503 8.83254L17.3031 9.2827L18.1781 8.81148Z" fill="#FFCC00"/>
            <path d="M18.1774 8.81157L17.4144 9.33987L17.1925 8.94464L18.1774 8.81157Z" fill="#FFCC00"/>
            <path d="M17.8546 9.80518L17.5478 8.92931L17.136 9.11864L17.8546 9.80518Z" fill="#FFCC00"/>
            <path d="M17.8544 9.80517L17.1162 9.24279L17.4235 8.90964L17.8544 9.80517Z" fill="#FFCC00"/>
            <path d="M15.122 5.22656L14.3838 4.66417L14.6911 4.33102L15.122 5.22656Z" fill="#FFCC00"/>
            <path d="M15.1222 5.22657L14.8154 4.3507L14.4036 4.54002L15.1222 5.22657Z" fill="#FFCC00"/>
            <path d="M15.4449 4.23296L14.682 4.76125L14.4601 4.36603L15.4449 4.23296Z" fill="#FFCC00"/>
            <path d="M15.4457 4.23286L14.5179 4.25393L14.5707 4.70409L15.4457 4.23286Z" fill="#FFCC00"/>
            <path d="M14.6005 3.61865L14.8672 4.50754L14.4227 4.59643L14.6005 3.61865Z" fill="#FFCC00"/>
            <path d="M14.6007 3.61865L14.334 4.50754L14.7784 4.59643L14.6007 3.61865Z" fill="#FFCC00"/>
            <path d="M14.0772 5.22656L14.8154 4.66417L14.5081 4.33102L14.0772 5.22656Z" fill="#FFCC00"/>
            <path d="M14.0771 5.22657L14.3838 4.3507L14.7956 4.54002L14.0771 5.22657Z" fill="#FFCC00"/>
            <path d="M13.7543 4.23271L14.5173 4.76101L14.7391 4.36579L13.7543 4.23271Z" fill="#FFCC00"/>
            <path d="M13.7535 4.23262L14.6813 4.25369L14.6285 4.70385L13.7535 4.23262Z" fill="#FFCC00"/>
            <path d="M16.0556 7.20411L16.3623 6.32824L16.7741 6.51756L16.0556 7.20411Z" fill="#FFCC00"/>
            <path d="M16.0557 7.2041L16.794 6.64171L16.4866 6.30856L16.0557 7.2041Z" fill="#FFCC00"/>
            <path d="M17.1005 7.2041L16.3623 6.64171L16.6696 6.30856L17.1005 7.2041Z" fill="#FFCC00"/>
            <path d="M17.1007 7.20411L16.7939 6.32824L16.3821 6.51756L17.1007 7.20411Z" fill="#FFCC00"/>
            <path d="M17.4235 6.21025L16.6605 6.73855L16.4386 6.34333L17.4235 6.21025Z" fill="#FFCC00"/>
            <path d="M17.4242 6.21016L16.4964 6.23122L16.5492 6.68138L17.4242 6.21016Z" fill="#FFCC00"/>
            <path d="M15.7328 6.21025L16.4958 6.73855L16.7177 6.34333L15.7328 6.21025Z" fill="#FFCC00"/>
            <path d="M15.732 6.21016L16.6598 6.23122L16.607 6.68138L15.732 6.21016Z" fill="#FFCC00"/>
            <path d="M16.5772 5.59595L16.3105 6.48484L16.755 6.57372L16.5772 5.59595Z" fill="#FFCC00"/>
            <path d="M16.5771 5.59595L16.8438 6.48484L16.3993 6.57372L16.5771 5.59595Z" fill="#FFCC00"/>
            <path d="M15.7301 11.5561L16.6579 11.5772L16.6051 12.0273L15.7301 11.5561Z" fill="#FFCC00"/>
            <path d="M15.7308 11.5562L16.4938 12.0845L16.7157 11.6893L15.7308 11.5562Z" fill="#FFCC00"/>
            <path d="M16.0536 12.5501L16.3604 11.6742L16.7722 11.8635L16.0536 12.5501Z" fill="#FFCC00"/>
            <path d="M16.0538 12.55L16.792 11.9877L16.4847 11.6545L16.0538 12.55Z" fill="#FFCC00"/>
            <path d="M17.0986 12.55L16.3603 11.9877L16.6677 11.6545L17.0986 12.55Z" fill="#FFCC00"/>
            <path d="M17.0987 12.5501L16.792 11.6742L16.3802 11.8635L17.0987 12.5501Z" fill="#FFCC00"/>
            <path d="M16.5753 10.9421L16.3086 11.831L16.753 11.9199L16.5753 10.9421Z" fill="#FFCC00"/>
            <path d="M16.5751 10.9421L16.8418 11.831L16.3974 11.9199L16.5751 10.9421Z" fill="#FFCC00"/>
            <path d="M17.4203 11.5563L16.4925 11.5774L16.5453 12.0276L17.4203 11.5563Z" fill="#FFCC00"/>
            <path d="M17.4195 11.5564L16.6566 12.0847L16.4347 11.6895L17.4195 11.5564Z" fill="#FFCC00"/>
            <path d="M13.8004 13.3454L14.7282 13.3665L14.6754 13.8166L13.8004 13.3454Z" fill="#FFCC00"/>
            <path d="M13.8012 13.3455L14.5641 13.8738L14.786 13.4786L13.8012 13.3455Z" fill="#FFCC00"/>
            <path d="M14.1239 14.3394L14.4307 13.4635L14.8425 13.6528L14.1239 14.3394Z" fill="#FFCC00"/>
            <path d="M14.1241 14.3394L14.8623 13.777L14.555 13.4438L14.1241 14.3394Z" fill="#FFCC00"/>
            <path d="M15.1689 14.3394L14.4306 13.777L14.738 13.4438L15.1689 14.3394Z" fill="#FFCC00"/>
            <path d="M15.169 14.3394L14.8623 13.4635L14.4505 13.6528L15.169 14.3394Z" fill="#FFCC00"/>
            <path d="M14.6456 12.7314L14.3789 13.6203L14.8234 13.7092L14.6456 12.7314Z" fill="#FFCC00"/>
            <path d="M14.6454 12.7314L14.9121 13.6203L14.4677 13.7092L14.6454 12.7314Z" fill="#FFCC00"/>
            <path d="M15.4906 13.3457L14.5628 13.3667L14.6156 13.8169L15.4906 13.3457Z" fill="#FFCC00"/>
            <path d="M15.4899 13.3458L14.7269 13.874L14.505 13.4788L15.4899 13.3458Z" fill="#FFCC00"/>
          </g>
          <defs>
            <clipPath id="clip0_1150_1995">
              <rect width="32" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg> {{ $t('order.europeanAccounts') }}
      </span>
      <div v-if="getQuantity('eur') > 0" class="flex items-center justify-end mb-4">
        <div class="flex items-center space-x-4">
          <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
            {{ getQuantity('eur') }}
          </span>
        </div>
      </div>

      <span v-if="getQuantity('usd') > 0" class="text-detail inline-flex items-center space-x-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 24 18" fill="none" style="margin-right: 15px;">
          <g clip-path="url(#clip0_1150_2222)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V18H0V0Z" fill="#F7FCFF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 11.0002V12.5002H24V11.0002H0ZM0 13.7498V15.2498H24V13.7498H0ZM0 5.49975V6.99975H24V5.49975H0ZM0 16.5V18H24V16.5H0ZM0 8.25V9.75H24V8.25H0ZM0 0V1.5H24V0H0ZM0 2.75025V4.25025H24V2.75025H0Z" fill="#E31D1C"/>
            <path d="M0 0H15V9.75H0V0Z" fill="#2E42A5"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.29177 2.20415L0.747266 2.5859L0.931016 1.9064L0.447266 1.4759H1.07952L1.29102 0.920898L1.53927 1.4759H2.07777L1.65477 1.9064L1.81827 2.5859L1.29177 2.20415ZM4.29177 2.20415L3.74727 2.5859L3.93102 1.9064L3.44802 1.4759H4.07952L4.29102 0.920898L4.53927 1.4759H5.07777L4.65477 1.9064L4.81827 2.5859L4.29177 2.20415ZM6.74727 2.5859L7.29177 2.2034L7.81827 2.5859L7.65477 1.9064L8.07777 1.4759H7.53927L7.29102 0.920898L7.07952 1.4759H6.44802L6.93102 1.9064L6.74727 2.5859ZM10.2918 2.2034L9.74727 2.5859L9.93102 1.9064L9.44802 1.4759H10.0795L10.291 0.920898L10.5393 1.4759H11.0778L10.6548 1.9064L10.8183 2.5859L10.2918 2.2034ZM0.747266 5.58665L1.29177 5.20415L1.81827 5.58665L1.65477 4.90715L2.07777 4.47665H1.53927L1.29102 3.92165L1.07952 4.47665H0.447266L0.931016 4.90715L0.747266 5.58665ZM4.29177 5.20415L3.74727 5.58665L3.93102 4.90715L3.44802 4.47665H4.07952L4.29102 3.92165L4.53927 4.47665H5.07777L4.65477 4.90715L4.81827 5.58665L4.29177 5.20415ZM6.74727 5.58665L7.29177 5.20415L7.81827 5.58665L7.65477 4.90715L8.07777 4.47665H7.53927L7.29102 3.92165L7.07952 4.47665H6.44802L6.93102 4.90715L6.74727 5.58665ZM10.2918 5.20415L9.74727 5.58665L9.93102 4.90715L9.44802 4.47665H10.0795L10.291 3.92165L10.5393 4.47665H11.0778L10.6548 4.90715L10.8183 5.58665L10.2918 5.20415ZM0.747266 8.58665L1.29177 8.20415L1.81827 8.58665L1.65477 7.90715L2.07777 7.47665H1.53927L1.29102 6.92165L1.07952 7.47665H0.447266L0.931016 7.90715L0.747266 8.58665ZM4.29177 8.20415L3.74727 8.58665L3.93102 7.90715L3.44802 7.47665H4.07952L4.29102 6.92165L4.53927 7.47665H5.07777L4.65477 7.90715L4.81827 8.58665L4.29177 8.20415ZM6.74727 8.58665L7.29177 8.20415L7.81827 8.58665L7.65477 7.90715L8.07777 7.47665H7.53927L7.29102 6.92165L7.07952 7.47665H6.44802L6.93102 7.90715L6.74727 8.58665ZM10.2918 8.20415L9.74727 8.58665L9.93102 7.90715L9.44802 7.47665H10.0795L10.291 6.92165L10.5393 7.47665H11.0778L10.6548 7.90715L10.8183 8.58665L10.2918 8.20415ZM12.7473 2.58665L13.2918 2.20415L13.8183 2.58665L13.6548 1.90715L14.0778 1.47665H13.5393L13.291 0.921648L13.0795 1.47665H12.4473L12.931 1.90715L12.7473 2.58665ZM13.2918 5.20415L12.7473 5.58665L12.931 4.90715L12.4473 4.47665H13.0795L13.291 3.92165L13.5393 4.47665H14.0778L13.6548 4.90715L13.8183 5.58665L13.2918 5.20415ZM12.7473 8.58665L13.2918 8.20415L13.8183 8.58665L13.6548 7.90715L14.0778 7.47665H13.5393L13.291 6.92165L13.0795 7.47665H12.4473L12.931 7.90715L12.7473 8.58665ZM2.79177 3.7034L2.24727 4.0859L2.43102 3.4064L1.94727 2.9759H2.57952L2.79102 2.4209L3.03927 2.9759H3.57777L3.15477 3.4064L3.31827 4.0859L2.79177 3.7034ZM5.24727 4.0859L5.79177 3.7034L6.31827 4.0859L6.15477 3.4064L6.57777 2.9759H6.03927L5.79102 2.4209L5.57952 2.9759H4.94727L5.43102 3.4064L5.24727 4.0859ZM8.79177 3.7034L8.24727 4.0859L8.43102 3.4064L7.94802 2.9759H8.57952L8.79102 2.4209L9.03927 2.9759H9.57777L9.15477 3.4064L9.31827 4.0859L8.79177 3.7034ZM2.24727 7.0859L2.79177 6.7034L3.31827 7.0859L3.15477 6.4064L3.57777 5.9759H3.03927L2.79102 5.4209L2.57952 5.9759H1.94727L2.43102 6.4064L2.24727 7.0859ZM5.79177 6.7034L5.24727 7.0859L5.43102 6.4064L4.94802 5.9759H5.57952L5.79102 5.4209L6.03927 5.9759H6.57777L6.15477 6.4064L6.31827 7.0859L5.79177 6.7034ZM8.24727 7.0859L8.79177 6.7034L9.31827 7.0859L9.15477 6.4064L9.57777 5.9759H9.03927L8.79102 5.4209L8.57952 5.9759H7.94802L8.43102 6.4064L8.24727 7.0859ZM11.7918 3.7034L11.2473 4.0859L11.431 3.4064L10.948 2.9759H11.5795L11.791 2.4209L12.0393 2.9759H12.5778L12.1548 3.4064L12.3183 4.0859L11.7918 3.7034ZM11.2473 7.0859L11.7918 6.7034L12.3183 7.0859L12.1548 6.4064L12.5778 5.9759H12.0393L11.791 5.4209L11.5795 5.9759H10.948L11.431 6.4064L11.2473 7.0859Z" fill="#F7FCFF"/>
          </g>
          <defs>
            <clipPath id="clip0_1150_2222">
              <rect width="32" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg> {{ $t('order.americanAccounts') }}
      </span>
      <div v-if="getQuantity('usd') > 0" class="flex items-center justify-end mb-4">
        <div class="flex items-center space-x-4">
          <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
            {{ getQuantity('usd') }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="warning-section mt-[3rem] bg-yellow-100 text-yellow-900 p-4 rounded-lg flex grid grid-cols-1 gap-6">
    <span class="text-sm font-semibold flex items-center">
      
      <div class="info-title">
        <span class="flex items-center gap-2"> 
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 3C8.82 3 3 8.82 3 16C3 23.18 8.82 29 16 29C23.18 29 29 23.18 29 16C29 8.82 23.18 3 16 3ZM10.8544 10.1462L17.4169 14.5837C17.8501 14.8957 18.143 15.3657 18.2324 15.8921C18.3217 16.4184 18.2003 16.9587 17.8943 17.3962C17.5883 17.8337 17.1224 18.1331 16.5974 18.2297C16.0724 18.3263 15.5304 18.2124 15.0887 17.9125C14.8947 17.7757 14.7256 17.6065 14.5887 17.4125L10.1512 10.85C10.0829 10.7521 10.0513 10.6334 10.0617 10.5145C10.0722 10.3956 10.1242 10.2842 10.2086 10.1999C10.293 10.1155 10.4044 10.0635 10.5233 10.053C10.6421 10.0425 10.7609 10.0742 10.8588 10.1425L10.8544 10.1462ZM16 27C9.9375 27 5 22.0656 5 16C4.99485 14.5206 5.29067 13.0555 5.86947 11.694C6.44828 10.3324 7.29797 9.10286 8.36687 8.08C8.45 7.99713 8.5488 7.93163 8.6575 7.88733C8.7662 7.84303 8.88263 7.82082 9.00001 7.82198C9.11738 7.82314 9.23335 7.84765 9.34116 7.89409C9.44896 7.94053 9.54644 8.00797 9.62791 8.09247C9.70938 8.17697 9.77322 8.27685 9.8157 8.38627C9.85817 8.4957 9.87844 8.61249 9.87532 8.72983C9.8722 8.84717 9.84575 8.96271 9.79752 9.06972C9.74928 9.17674 9.68023 9.27307 9.59437 9.35312C8.69741 10.2116 7.98439 11.2436 7.49864 12.3862C7.01289 13.5289 6.76456 14.7584 6.76875 16C6.76875 21.09 10.91 25.2313 16 25.2313C21.09 25.2313 25.2313 21.09 25.2313 16C25.2313 11.2081 21.5612 7.2575 16.8844 6.8125V10.25C16.8844 10.4846 16.7912 10.7095 16.6253 10.8753C16.4595 11.0412 16.2346 11.1344 16 11.1344C15.7654 11.1344 15.5405 11.0412 15.3747 10.8753C15.2088 10.7095 15.1156 10.4846 15.1156 10.25V5.88438C15.1156 5.64982 15.2088 5.42488 15.3747 5.25903C15.5405 5.09317 15.7654 5 16 5C22.0656 5 27 9.9375 27 16C27 22.0625 22.0656 27 16 27Z" fill="#EF9100"/>
          </svg>
          {{ $t('order.estimatedWait1') }}
        </span>
        <ul class="step-color list-disc ml-[4rem]">
          <li v-for="(wait, index) in getWaitingList()" :key="index">{{ wait }} {{ $t('order.estimatedWait2') }}</li>
        </ul>
      </div>
    </span>

    <p class="info-text mt-5">
      <span class="bolt-step-info">{{ $t('order.Warning') }} </span>
      <br>
      <span class="text-step-info">{{ $t('order.fullWarning')}}</span>
      <br>
      <span class="text-step-info">{{ $t('order.fullWarning2')}}</span>
    </p>
  </div>

  <div class="immediate-section mt-[3rem]">
    <h3 class="next-step mb-7">{{ $t('order.nextSteps') }}</h3>
    <div class="grid grid-cols-1 gap-6">
      <div class="flex items-start gap-3">
        <span class="step-color whitespace-nowrap flex-shrink-0 self-start">
          Step 1
        </span>
        <div class="grid grid-cols-1">
          <span class="bolt-step">{{ $t('order.step1_title') }}</span>
          <span class="text-step">
            {{ $t('order.step1_desc') }}
          </span>
        </div>
      </div>
      <div class="flex items-start gap-3">
        <span class="step-color whitespace-nowrap flex-shrink-0 self-start">
          Step 2
        </span>
        <div class="grid grid-cols-1">
          <span class="bolt-step">{{ $t('order.step2_title') }}</span>
          <span class="text-step">
            {{ $t('order.step2_desc') }}
          </span>
        </div>
      </div>
      <div class="flex items-start gap-3">
        <span class="step-color whitespace-nowrap flex-shrink-0 self-start">
          Step 3
        </span>
        <div class="grid grid-cols-1">
          <span class="bolt-step">{{ $t('order.step3_title') }}</span>
          <span class="text-step">
            {{ $t('order.step3_desc') }}
          </span>
        </div>
      </div>
    </div>
  </div>


  <div class="footer mt-8 flex justify-center">
    <button @click="openBlog"  class="button-continu">
      {{ $t('order.blog') }}
    </button>
  </div>

  <div class="text-details-success text-center p-4 rounded-lg font-semibold mt-7">
    {{ $t('order.help') }}
    <a :href="getFaqUrl()" target="_blank" rel="noopener noreferrer" class="step-color">Helpcenter</a>  
    {{ $t('order.ou') }}  
    <a :href="getTrainingUrl()" target="_blank" rel="noopener noreferrer" class="step-color">
      {{ $t('order.training') }}
    </a>
  </div>
</div>

</template>

<script>
import axios from '../plugins/axios';


export default {
name: 'WaitingView',
data() {
return {
  accounts: [],
  isLoading: true, 
  isLoadingStrong: true,
  langue: localStorage.getItem('langue') || navigator.language,
  europeanAVDays: null,
  americanAVDays: null,
  isBig: false,
};
},
computed: {

},
methods: {
  hasSubscription(currency) {
    return this.accounts.subscriptions && this.accounts.subscriptions.some(sub => sub.currency === currency && sub.quantity > 0);
  },
  updateIsMobile() {
    this.isMobile = window.innerWidth <= 768; 
    this.isBig = window.innerWidth <= 1700; 
  },
  getQuantity(currency) {
    if (!this.accounts.subscriptions) return 0;
    const sub = this.accounts.subscriptions.find(
      (s) => s.currency === currency
    );
    return sub ? sub.quantity : 0;
  },
  getRenewalDate(currency) {
    if (!this.accounts.subscriptions) return '';
    const sub = this.accounts.subscriptions.find(
      (s) => s.currency === currency
    );
    return sub ? sub.renewalDate : '';
  },

  /**
     * Génère l'URL de la FAQ en fonction de la langue actuelle
     */
     getFaqUrl() {
      const baseUrl = "https://help.mirrorprofiles.com/";
      return `${baseUrl}${this.getLangSegment()}/`;
    },

    /**
     * Génère l'URL des formations en fonction de la langue actuelle
     */
    getTrainingUrl() {
      const baseUrl = "https://mirrorprofiles.com/";
      return `${baseUrl}${this.getLangSegment()}/formations/`;
    },

    /**
     * Génère l'URL des formations en fonction de la langue actuelle
     */
     getBlogUrl() {
      const baseUrl = "https://mirrorprofiles.com/";
      return `${baseUrl}${this.getLangSegment()}/blog/`;
    },
    openBlog() {
      window.open(this.getBlogUrl(), "_blank");
    },

    /**
     * Convertit la langue détectée en un segment d'URL valide
     */
    getLangSegment() {
      const langMap = {
        'fr': 'fr',
        'en': 'en',
        'es': 'es',
        'de': 'de'
      };

      const langCode = this.langue.split('-')[0];
      return langMap[langCode] || 'en';
    },

    getWaitingList() {
      const waitingList = [];
      if (this.hasSubscription('eur')) {
        waitingList.push(`${this.$t('order.europeanAccounts5')} ${this.europeanAVDays}`);
      }
      if (this.hasSubscription('usd')) {
        waitingList.push(`${this.$t('order.americanAccounts5')} ${this.americanAVDays}`);
      }
      if (waitingList.length === 0) {
        return [this.$t('order.noActiveSubscription')];
      }
      return waitingList;
    }
},
async mounted() {
  const response = await axios.get('/api/stripe/subscriptions');
  this.accounts = response.data;

  const url = `/api/products-prices?type=main`;   
  const responsess = await axios.get(url);
  const products = responsess.data.products;
  if (!products || !Array.isArray(products)) {
    console.error('Invalid products data:', products);
    return;
  }

  this.updateIsMobile();
  window.addEventListener("resize", this.updateIsMobile);

  if (localStorage.getItem('customerCurrency')) {
    this.selectedCurrency = localStorage.getItem('customerCurrency').toLowerCase();
    this.lockedCurrency = true;
  } else {
    this.lockedCurrency = false;
  }

  this.americanProduct = null;
  this.europeanProduct = null;

  const currencyMap = {
    eur: 'eu',
    usd: 'us',
  };
  const currencyLabel = currencyMap[this.selectedCurrency];

  products.forEach(product => {
    if (!product.prices) {
      console.error('Product has no prices:', product);
      return;
    }
    const priceLabel = product.prices.price_label.toLowerCase();

    if (
      (product.nameUS === 'American Profile' || product.nameEU === 'Profil Américain') &&
      priceLabel === currencyLabel
    ) {
      this.americanProduct = product;
    } else if (
      (product.nameUS === 'European Profile' || product.nameEU === 'Profil Européen') &&
      priceLabel === currencyLabel
    ) {
      this.europeanProduct = product;
    }
  });
  this.europeanAVDays = this.europeanProduct.prices.days;
  this.americanAVDays = this.americanProduct.prices.days;

  this.isLoading = false; 
  this.isLoadingStrong = false;
},

};
</script>

<style scoped>
.warning-section{
  border-radius: 10px;
  padding: 2rem;
  background: #FFF7D1;
}


.immediate-section{
border-radius: 10px;
padding: 2rem;
background: #fff;
box-shadow: 0px 20px 40px rgba(30, 147, 253, 0.2);
}

.recurring-section {
color:#FFF;
border-radius: 5px;
padding: 2rem;
background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
box-shadow: 0px 20px 40px rgba(30, 147, 253, 0.2);
}

.text-success{
  color: #000;
text-align: center;
font-family: Montserrat;
font-size: 26px;
font-style: normal;
font-weight: 700;
line-height: 140%; /* 36.4px */
}

.text-details-success{
color: #000;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 140%; 
}

.next-step{
color: #000;
font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 140%; 
}

.list-note{
color: #000;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 140%; 
}

.text-help{
color: #FFF;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: normal;
align-items: center;
}

.visit-faq {
border-radius: 50px; 
background: #FFF; 
border: 2px solid #1E93FD; 
font-weight: bold; 
text-align: center; 
font-size: 16px;
color: #1E93FD; 
background: #FFF;
}

.visit-faq span {
background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent; 
}

.visit-faq:hover {
background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
color: #FFF;
border: 2px solid #FFF;
}

.visit-faq:hover span {
-webkit-text-fill-color:#FFF; 
}

.contact-us{
border-radius: 50px;
font-weight: bold; 
text-align: center; 
font-size: 16px;
border: 2px solid #FFF;
}

.contact-us span{
-webkit-text-fill-color:#FFF; 
}


.contact-us:hover {
background: #FFF;
color: #1E93FD;
border: 2px solid #1E93FD;
}


.contact-us:hover span {
background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent; 
}



.key-success{
color: #000;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 140%; 
}

.text-waiting{
color: #000;
text-align: center;
font-family: Montserrat;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 140%; 
}

.button-our-guides{
border-radius: 50px;
background: linear-gradient(90deg, #1E93FD 0%, #3153C7 100%);
color: #FFF;
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: normal;
text-transform: uppercase;
transition: all 0.3s ease-in-out; 
}

.button-our-guides:hover {
background: linear-gradient(90deg, #3153C7 0%, #1E93FD 100%);
transform: scale(1.05); 
box-shadow: 0px 4px 10px rgba(30, 147, 253, 0.4); 
}

.button-our-guides:disabled {
background: linear-gradient(90deg, #cccccc 0%, #999999 100%);
color: #666666;
cursor: not-allowed;
transform: none; 
box-shadow: none;
opacity: 0.6;
}

.button-our-guides:disabled:hover {
transform: none; 
background: linear-gradient(90deg, #cccccc 0%, #999999 100%);
box-shadow: none;
}

.custom-border{
border-radius: 62px;
border: 1px solid var(--gradient, #1E93FD);
}

@media (max-width: 767px) {

}



.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
}

.no-arrows {
-moz-appearance: textfield;
}

.button-selector {
background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
color: white;
padding: 0.5rem 1rem;
font-size: 17px; 
}


.flex-input-container {
display: flex;
align-items: center;
border: 1px solid #1E93FD;
border-radius: 10px;
overflow: hidden;
}


.flex-input-container input {
width: 50px; 
text-align: center;
border-left: 1px solid #d1d5db;
border-right: 1px solid #d1d5db;
outline: none;
font-size: 14px;
padding: 0.5rem;
}


.text-gender{
background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3153C7 100%));
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
font-family: Montserrat;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 140%; 
}

.button-selector:disabled {
background: var(--gradient, linear-gradient(90deg, #cccccc 0%, #999999 100%));
cursor: not-allowed;
}

.number-blue {
font-family: Montserrat;
font-style: normal;
font-weight: 700;
line-height: 140%;
margin-right: 15px;
background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
-webkit-background-clip: text;
background-clip: text;
-webkit-text-fill-color: transparent;
text-fill-color: transparent;
}


.button-continu {
  width: 100%; /* Permet au bouton de s'adapter à la taille du texte */
  padding: 12px 24px; /* Ajuste le padding pour un meilleur rendu */
  background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
  box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
  transition: background 1s ease, box-shadow 1s ease;
  text-align: center; 
  display: flex;
  align-items: center; 
  justify-content: center; 
  color: #FFF;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  white-space: nowrap; /* Empêche le texte de passer à la ligne */
  border-radius: 50px; /* Arrondi comme avec `rounded-full` */
}

.button-continu:hover {
  background: linear-gradient(90deg, #3154C8 0%, #3154C8 100%);
  box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
}

.button-continu:disabled {
  background: linear-gradient(90deg, #B0B0B0 0%, #8C8C8C 100%);
  box-shadow: none;
  cursor: not-allowed;
  color: #E0E0E0;
}


.text-detail{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}

.date-detail{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
}

.quantity-display{
  border-radius: 5px;
  background: #1E93FD;
}

.step-color{
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; 
  background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


.bolt-step{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
}


.text-step{
  color: #818181;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
}

.info-title{
  color: #000;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; 
}

.info-text{
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; 
}

.text-step-info{
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.bolt-step-info{
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; 
}


</style>
